var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-4",style:({ backgroundColor: '#ffffff', border: _vm.data.hasRedLine ? '2px solid red' : 'none', borderRadius: _vm.data.hasRedLine ? '4px' : '0', padding: _vm.data.hasRedLine ? '4px' : '16px' })},[_c('hr',{style:({ 
        border: 'none', 
        borderTop: ((_vm.data.thickness || 2) + "px " + (_vm.data.style || 'solid') + " " + (_vm.data.color || '#e5e7eb')), 
        width: _vm.data.width || '100%', 
        margin: '0' 
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }